import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Field, reduxForm, Form} from 'redux-form'
import CustomSelect from "views/Components/CustomSelect.jsx"
import ValidatedCustomInput from "views/Components/ValidatedCustomInput.jsx"

import moment from 'moment'

import withStyles from "@material-ui/core/styles/withStyles";
import styles from "assets/jss/material-dashboard-pro-react/views/form";

import TextField from "@material-ui/core/TextField";
// @material-ui/icons
import MoreIcon from "@material-ui/icons/More";
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver";
import EmailIcon from "@material-ui/icons/Email";
import RoomIcon from "@material-ui/icons/Room";
import PhoneIcon from "@material-ui/icons/Phone";
// core components
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

// @material-ui/core components
import FormControl from "@material-ui/core/FormControl";

import {required} from 'views/utils/validations'
import {formatToSelectValues} from 'views/utils/helpers'
import {
  clientSave,
  clientsFetch,
  clientFetch,
  clientReassignIb,
  setClientViewFilter
} from 'actions/clients'

import {
  danger,
  success,
} from 'actions/notification'

import {
  profilesFetch
} from 'actions/profiles'
import {
  ibsFetchAll
} from 'actions/ibs'
const dbSources={
  ANTELOPE: {label:'ANTELOPE', value:'ANTELOPE'},
  MYSCOPE: {label:'MYSCOPE', value:'MYSCOPE'},
  GHOST: {label:'GHOST', value:'GHOST'},
}



const validate = values => {

 const errors = {}

 const requiredFields = [

'name',
'email',
/*'address',
'phoneNumber',*/
'ibid',
'profileid',
'registrationDate',
/*'registrationLink',*/
'dbResource'

 ]

if (!values.email) {
    errors.email = 'Required'
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Invalid email address'
  }

/*if (!values.phoneNumber) {
    errors.phoneNumber = 'Required'
  } else if (!/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s./0-9]*$/g.test(values.phoneNumber)) {
    errors.phoneNumber = 'Invalid Phone Number'
  }*/

 requiredFields.forEach(field => {

 if (!values[field]) {

 errors[field] = 'Required'

 }

 })

 

 return errors

}

class CreateEditClientForm extends Component {
		state= {
			form:{
				...this.props.clientData
			}
		}

		 
		  componentDidMount(){

		  	//console.log('this.props',this.props);

		    //this.props.ibsFetchAll(); 
		  
		  }

		  componentWillUnmount() {

		  	this.setState({});
		  }

		componentDidUpdate(prevProps, prevState){
			if (prevProps.clientData !== this.props.clientData) {
				if (this.props.editMode) {
					this.props.initialize({...this.props.clientData});
				}
			}
		}
		//OnChange action for all inputs and selects
		change(event,name){
			this.setState({
				...this.state,
				form:{
					...this.state.form,
					[name]:event.target.value
				},
			})
		}

		getInput(data) {
			return <Field
							name={data.key}
							placeholder={data.name}
							id={data.key}
							icon={data.icon}
							props={{
								name: data.key
							}}
							validate={data.required ? [required] : []}
							required={data.required}
							component={ValidatedCustomInput}
						/>
		}
		submit(values){
			const clientId = this.props.clientid
			//const ibid = clientId ? this.props.ibid : values.ibid
			//const profileid = clientId ? this.props.profileid : values.profileid
			if(this.state.form.registrationDate) {
				let date = moment(this.state.form.registrationDate).format()
				values.registrationDate = Date.parse(date)
			}
			this.props.save(values)
				.then(e=>{
					this.props.success(e.name+ ' '+(clientId?'Edited':'Added')+'!',4); 
					// this.props.setClientViewFilter({filterName: 'selectedProfileId', value: profileid})
					// this.props.setClientViewFilter({filterName: 'selectedIbId', value: ibid})
					//	this.props.fetchAll(ibid, profileid)
					this.props.fetchAll()
					this.props.goBack()
				})
				.catch(e=>{this.props.danger(e+'',4);})
		}

    render(){
				const {clientData, classes, ibs, profiles, handleSubmit, editMode, ibList} = this.props

				const registrationDate = this.state.form.registrationDate 
					? moment(this.state.form.registrationDate).format('YYYY-MM-DD')
					: clientData.registrationDate ? moment(clientData.registrationDate).format('YYYY-MM-DD') :''
				
        return(
          <Form onSubmit={handleSubmit(this.submit.bind(this))}>
						<GridContainer justify="center">

							{!editMode && /*Header Information*/
								<GridItem xs={12} sm={12}>
									<h4 className={classes.infoText}>
										Complete information
									</h4>
								</GridItem>
							}
							<GridItem style={{marginTop:"25px"}} xs={12} sm={12} md={12} lg={10}>

								{/*Name input*/}
			                    {this.getInput({
									key:'name',
									name:'Name',
									icon:<RecordVoiceOverIcon className={this.props.classes.inputAdornmentIcon}/>,
									type:'text',
									required:true
									})
								}
								{/*Email input*/}
								{this.getInput({
									key:'email',
									name:'Email',
									icon:<EmailIcon className={this.props.classes.inputAdornmentIcon}/>,
									type:'email',
									required:true
									})
								}

								{/*Address input*/}
								{this.getInput({
									key:'address',
									name:'Address',
									icon:<RoomIcon className={this.props.classes.inputAdornmentIcon}/>,
									type:'text',
									required:false
								})}
													
								{/*Phone input*/}
								{this.getInput({
									key:'phoneNumber',
									name:'Phone',
									icon:<PhoneIcon className={this.props.classes.inputAdornmentIcon}/>,
									type:'text',
									required:false
								})}

								{/*External id input*/}
								{this.getInput({key: 'externalId', name: 'External Id', type: 'number'})}

								{/*Registration link input*/}
								{this.getInput({
									key:'registrationLink',
									name:'Registration Link',
									icon:<MoreIcon className={this.props.classes.inputAdornmentIcon}/>,
									type:'text',
									required:false
								})}

								{/*Registration Date input*/}
								<FormControl
									fullWidth
									style={{paddingTop:'27px', marginBottom: '17px'}}
								>
									<TextField
										id="registrationDate"
										name="registrationDate"
										label="Registration Date"
										type="date"
										onChange={(event) => this.change(event, "registrationDate")}
										value={registrationDate}
										//defaultValue={registrationDate}
										className={classes.textField}
										InputLabelProps={{
											shrink: true,
										}}
									/>
								</FormControl>

								<Field
									name="dbResource"
									options={formatToSelectValues(dbSources)}
									placeholder="DB Resource *"
									id="dbResource"
									props={{
										name:"dbResource",
									}}
									validate={[required]}
									component={CustomSelect}
								/>

								{!editMode && 
									<div>
										{ ibList.length &&
										<Field
											name="ibid"
											options={ibList.map((i) => {return {value: i.ibId, label: `${i.firstName} ${i.lastName}`}})}
											placeholder="IB *"
											id="ibid"
											props={{
												name:"ibid"
											}}
											validate={[required]}
											component={CustomSelect}
										/>
										}
										<Field
											name="profileid"
											options={profiles.map((i) => {return {value: i.profileId, label: i.name}})}
											placeholder="Profile *"
											id="profileid"
											props={{
												name:"profileid"
											}}
											validate={[required]}
											component={CustomSelect}
										/>
									</div>
								}
							</GridItem>
							<GridItem xs={12} sm={12} md={12} lg={10}>
								<span style={{color: '#AAAAAA', fontSize:'11.5px'}}>* Required fields</span>
							</GridItem>
							<GridItem xs={12} sm={12} md={12} lg={10}>
									<Button type="submit"  className={classes.submit} color="success">Submit</Button>
							</GridItem>
						</GridContainer>
        	</Form>
        )
    }
}

function mapStateToProps(state) {
	return {
		clients:state.clients,
		ibs: state.ibs,
		profiles: state.profiles.list
	}
}

function mapDispatchToProps(dispatch) {
	return {
		fetch:(clientID, ibid, profileid)=>dispatch(clientFetch(clientID, ibid, profileid)),
		fetchAll:(ibid, profileid) => dispatch(clientsFetch(ibid, profileid)),
		save:(data)=>dispatch(clientSave(data)),
		danger:(text,sec)=>dispatch(danger(text,sec)),
		success:(text,sec)=>dispatch(success(text,sec)),
		profilesFetch: () => dispatch(profilesFetch()),
		ibsFetchAll: () => dispatch(ibsFetchAll()),
		clientReassignIb: (data) => dispatch(clientReassignIb(data)),
		setClientViewFilter: (data) => dispatch(setClientViewFilter(data))
	}
}

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(reduxForm({ form: 'createEditClientForm', validate })(CreateEditClientForm)))



// WEBPACK FOOTER //
// ./src/views/Clients/CreateEditClientForm.jsx